import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PriceBlock } from './PriceBlock';
import { PRICE_NOW } from './salesData';
const WHAT_YOU_GET = ['Los 6 tomos completos en PDF', 'Los bonos incluidos en la oferta', 'Acceso inmediato una vez acreditado el pago, con el link de descarga por email', 'Archivos para leer en celular, tablet o computadora', 'Podés empezar a aplicarlo el mismo día'];
export function FinalCta() {
  return <section className="bg-blush py-12 sm:py-16" data-id="element-68" data-mp="1jbaj0hj66o3h">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-69" data-mp="1eejyni0c16c9">
        <h2 className="font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-70" data-mp="1ec7m5kdcfo6l">
          Vos ya sabés hacer tu trabajo.
          <span className="block bg-gradient-to-r from-[#3e4ee9] via-[#9750d8] to-[#ff7396] bg-clip-text text-transparent" data-id="element-71" data-mp="1o3bqlq5e7qn6">
            Ahora hacé que tu Instagram esté a la altura.
          </span>
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-72" data-mp="1x5b9knzyx4sr">
          Dejá de improvisar contenido y empezá a trabajar con un sistema pensado para profesionales
          de estética.
        </p>

        <ul className="mx-auto mt-7 max-w-md space-y-2 text-left" data-id="element-73" data-mp="s4xqjl6szro7">
          {WHAT_YOU_GET.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-ink/75" data-id="element-74" data-mp="x5v5zq0fi7m0">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose" aria-hidden data-id="element-75" data-mp="120sd2re5e6w9" />
              {item}
            </li>)}
        </ul>

        <PriceBlock className="mt-7" eyebrow="Acceso completo · 6 tomos + bonos" ctaLabel="QUIERO ESTÉTICA DIGITAL PRO" data-id="element-76" data-mp="1b31pxnww2cct" />

        <p className="mt-3 text-[0.78rem] font-medium text-ink/60" data-id="element-77" data-mp="1fwmbuhl7jfvn">
          Acceso inmediato · Pago único {PRICE_NOW}
        </p>
      </div>
    </section>;
}